/**
 * @generated SignedSource<<18c42c39c325cd6a824e917fdd8e0eb2>>
 * @relayHash 03d5875c1b03d41998137db774a62625
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ee47ae4cc0c2824c18ebc9cfb0011423e0d1f4d9b221b72832c635864569c483

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectPageAggQuery$variables = {
  containerId: string;
  isCombinedAggQueryEnabled: boolean;
  searchQuery: string;
};
export type ProjectPageAggQuery$data = {
  readonly projects_search?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly key: string;
        readonly " $fragmentSpreads": FragmentRefs<"ProjectPageAgg">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type ProjectPageAggQuery = {
  response: ProjectPageAggQuery$data;
  variables: ProjectPageAggQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isCombinedAggQueryEnabled"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchQuery"
},
v3 = [
  {
    "kind": "Variable",
    "name": "containerId",
    "variableName": "containerId"
  },
  {
    "kind": "Variable",
    "name": "searchString",
    "variableName": "searchQuery"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "key"
},
v6 = {
  "kind": "ScalarField",
  "name": "count"
},
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v8 = {
  "kind": "ScalarField",
  "name": "name"
},
v9 = {
  "kind": "ScalarField",
  "name": "picture"
},
v10 = [
  (v7/*: any*/),
  (v4/*: any*/),
  {
    "kind": "TypeDiscriminator",
    "abstractKey": "__isUser"
  },
  (v8/*: any*/),
  (v9/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "concreteType": "AtlassianAccountUserExtendedProfile",
        "kind": "LinkedField",
        "name": "extendedProfile",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "jobTitle"
          }
        ]
      }
    ],
    "type": "AtlassianAccountUser"
  },
  {
    "kind": "ScalarField",
    "name": "accountId"
  }
],
v11 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v12 = [
  (v4/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ProjectPageAggQuery",
    "selections": [
      {
        "condition": "isCombinedAggQueryEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "TownsquareProjectConnection",
            "kind": "LinkedField",
            "name": "projects_search",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "kind": "FragmentSpread",
                        "name": "ProjectPageAgg"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProjectPageAggQuery",
    "selections": [
      {
        "condition": "isCombinedAggQueryEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "TownsquareProjectConnection",
            "kind": "LinkedField",
            "name": "projects_search",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "concreteType": "TownsquareContributorConnection",
                        "kind": "LinkedField",
                        "name": "contributors",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareContributorEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareContributor",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareTeamContributor",
                                    "kind": "LinkedField",
                                    "name": "teamContributor",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareUserConnection",
                                        "kind": "LinkedField",
                                        "name": "contributingMembers",
                                        "plural": false,
                                        "selections": [
                                          (v6/*: any*/),
                                          {
                                            "concreteType": "TownsquareUserEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": (v10/*: any*/)
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "concreteType": "TeamV2",
                                        "kind": "LinkedField",
                                        "name": "team",
                                        "plural": false,
                                        "selections": [
                                          (v4/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "displayName"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "smallAvatarImageUrl"
                                          },
                                          {
                                            "concreteType": "TeamMemberConnectionV2",
                                            "kind": "LinkedField",
                                            "name": "members",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "TeamMemberEdgeV2",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "TeamMemberV2",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "LinkedField",
                                                        "name": "member",
                                                        "plural": false,
                                                        "selections": [
                                                          (v7/*: any*/),
                                                          (v4/*: any*/),
                                                          (v8/*: any*/),
                                                          (v9/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "profileUrl"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "state"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "permission"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "name": "userContributor",
                                    "plural": false,
                                    "selections": (v10/*: any*/)
                                  }
                                ]
                              }
                            ]
                          },
                          (v11/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TownsquareProjectCapabilities",
                        "kind": "LinkedField",
                        "name": "capabilities",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "canAddContributors"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canRemoveContributors"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canAddWatchers"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canRemoveWatchers"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canManageAccess"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canManageOwnership"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canAddRelatedProjects"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canRemoveRelatedProjects"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canAddLinkedFocusAreas"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canRemoveLinkedFocusAreas"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canAddLinkedGoals"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canRemoveLinkedGoals"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canAddRelatedLink"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canEditRelatedLink"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canRemoveRelatedLink"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canAddTags"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canRemoveTags"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canEditStartDate"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canEditCustomFields"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canAddLinkedWorkItems"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canRemoveLinkedWorkItems"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canEditMetadata"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canEditTargetDate"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canEditStatus"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canWatchProject"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canCreateUpdates"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canEditUpdates"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canDeleteUpdates"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canArchiveProject"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canCommentOnProject"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canCommentOnUpdates"
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "name": "owner",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v4/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TownsquareProjectAccessConnection",
                        "kind": "LinkedField",
                        "name": "access",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareProjectAccessEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "role"
                              },
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v12/*: any*/),
                                    "type": "User",
                                    "abstractKey": "__isUser"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v12/*: any*/),
                                    "type": "AppUser"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v12/*: any*/),
                                    "type": "AtlassianAccountUser"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v12/*: any*/),
                                    "type": "CustomerUser"
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isPrivate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "accessLevel"
                      },
                      (v11/*: any*/),
                      {
                        "concreteType": "TownsquareUserConnection",
                        "kind": "LinkedField",
                        "name": "watchers",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "concreteType": "TownsquareUserEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v4/*: any*/),
                                  (v9/*: any*/),
                                  (v8/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "watching"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "uuid"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "ee47ae4cc0c2824c18ebc9cfb0011423e0d1f4d9b221b72832c635864569c483",
    "metadata": {},
    "name": "ProjectPageAggQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1eacf4a16e8be68ab3af6efec73b78e2";

export default node;
